export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_workshop_name') || '车间名称',
    field: 'workshopName',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_workshop_status') || '车间状态',
    field: 'workshopStatus',
    width: 120,
    align: 'center',
    slots: { default: 'workshopStatus' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
]

